import { faCheck, faChevronDown, faSync, faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material"
import theme from "css/theme/light"
import React, { useEffect, useState } from "react"
import { useStyles } from "./useStyles"
import { useTranslation } from "react-i18next"

const contractHeader = (errorMessages, t) => {
  if (errorMessages) {
    if (
      (errorMessages.invalidRows &&
        errorMessages.invalidRows.length > 0 &&
        errorMessages.nrOfValidRows &&
        errorMessages.nrOfValidRows > 0) ||
      (errorMessages.nrOfUpdatedRows && errorMessages.nrOfUpdatedRows > 0)
    ) {
      return t("vehicleregistry.successful_rows_imported", "Successful rows imported!")
    } else if (
      (errorMessages.invalidRows &&
        errorMessages.invalidRows.length < 1 &&
        errorMessages.nrOfValidRows &&
        errorMessages.nrOfValidRows > 0) ||
      (errorMessages.nrOfUpdatedRows && errorMessages.nrOfUpdatedRows > 0)
    ) {
      return t("vehicleregistry.import_successful", "Import successful!")
    } else {
      return t("vehicleregistry.no_rows_could_be_imported", "No rows could be imported")
    }
  }
}

const contractErrorMessage = (errorMessages, t) => {
  if (errorMessages) {
    if (
      (errorMessages.invalidRows &&
        errorMessages.invalidRows.length > 0 &&
        errorMessages.nrOfValidRows &&
        errorMessages.nrOfValidRows > 0) ||
      (errorMessages.nrOfUpdatedRows && errorMessages.nrOfUpdatedRows > 0)
    ) {
      return t(
        "vehicleregistry.you_can_review_the_failed_lines_below",
        "You can review the failed lines below"
      )
    } else if (
      (errorMessages.invalidRows &&
        errorMessages.invalidRows.length < 1 &&
        errorMessages.nrOfValidRows &&
        errorMessages.nrOfValidRows > 0) ||
      (errorMessages.nrOfUpdatedRows && errorMessages.nrOfUpdatedRows > 0)
    ) {
      return t("vehicleregistry.all_rows_could_be_imported", "All rows could be imported")
    } else {
      return t(
        "vehicleregistry.you_can_review_the_failed_lines_below_and",
        "You can review the failed lines below and redo the import"
      )
    }
  }
}
export const SuccessArea = ({ submitResult }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const [errorMessages, setErrorMessages] = useState()
  useEffect(() => {
    setErrorMessages(submitResult.data)
  }, [submitResult.data])

  return (
    <Container>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <Box bgcolor="background.dark" color="foreground.inverted" borderRadius="8px" padding={10}>
            <Typography variant="h1" align="center" gutterBottom>
              {contractHeader(errorMessages, t)}
            </Typography>
            <Typography variant="bodySmall" align="center">
              {contractErrorMessage(errorMessages, t)}
            </Typography>
            <Box marginTop={5} />
            <Grid container direction="row" justifyContent="center">
              {errorMessages && (
                <Grid item>
                  <List className={classes.list}>
                    <ListItem>
                      <ListItemIcon>
                        <FontAwesomeIcon color={theme.palette.success["main"]} icon={faCheck} />
                      </ListItemIcon>

                      <ListItemText
                        primary={`${errorMessages.nrOfValidRows && errorMessages.nrOfValidRows} ${t(
                          "vehicleregistry.agreements_was_imported",
                          "agreement was imported"
                        )}`}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FontAwesomeIcon color={theme.palette.primary["main"]} icon={faSync} />
                      </ListItemIcon>

                      <ListItemText
                        primary={`${errorMessages.nrOfUpdatedRows && errorMessages.nrOfUpdatedRows} ${t(
                          "vehicleregistry.updated_agreements",
                          "updated agreements"
                        )}`}
                      />
                    </ListItem>
                    <Accordion className={classes.accordion}>
                      <ListItem>
                        <ListItemIcon>
                          <FontAwesomeIcon color={theme.palette.error.main} icon={faTimes} />
                        </ListItemIcon>
                        <AccordionSummary expandIcon={<FontAwesomeIcon icon={faChevronDown} />}>
                          <Typography>
                            {`${errorMessages.invalidRows && errorMessages.invalidRows.length} ${t(
                              "vehicleregistry.agreement_could_not_be_imported",
                              "agreement could not be imported"
                            )}`}
                          </Typography>
                        </AccordionSummary>
                      </ListItem>
                      <AccordionDetails>
                        {errorMessages.invalidRows &&
                          errorMessages.invalidRows.map((row, index) => (
                            <Grid
                              key={index}
                              container
                              direction="row"
                              justifyContent="space-between"
                              spacing={2}>
                              <Grid item>
                                <Typography>
                                  {t("global.row_no", "Row no")}: {row.rowNr}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography>{row.errorMessage}</Typography>
                              </Grid>
                            </Grid>
                          ))}
                      </AccordionDetails>
                    </Accordion>
                  </List>
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}
